<template>
    <div class="guide-picture-wrapper">
        <AddRefCoverPanel
            class="image-upload-strategy"
            :no-cover-icon="noCoverIcon"
            :imageUrl="data.image"
            :operate-icons="operateIcons"
            :view-icon="viewIcon"
            :ishorizontal="true"
            @viewClick="viewHandler"
            @change="imageChange"
        />
    </div>
</template>

<script>
import AddRefCoverPanel from '@/views/zhiji/components/coverPanel/AddRefCoverPanel.vue';

export default {
    name: "GuidePicture",
    props: ["data"],
    components: {
        AddRefCoverPanel
    },
    data() {
        return {
            isEditing: !this.data.image,
            viewIcon: {
                position: "-110px -85px"
            }
        };
    },
    computed: {
        noCoverIcon() {
            return {
                position: "-145px -50px",
                label: this.$t("zhiji.answer.addPicture")
            };
        },
        operateIcons() {
            return [
                {
                    type: "update",
                    position: "-38px -77px",
                    name: this.$t("zhiji.materialLibrary.replacePic")
                }
            ];
        }
    },
    methods: {
        viewHandler() {
            this.$store.commit("zhiji/showModal", {
                type: "ImageViewModal",
                data: {
                    url: this.data.image
                }
            });
        },
        imageChange({ value }) {
            if (value) {
                this.commitUpdate({
                    image: value
                });
            }
        },
        commitUpdate(updateData) {
            updateData.updateState = "update";
            const newData = Object.assign({}, this.data, updateData);
            this.$emit("updateContent", newData);
        }
    }
};
</script>

<style lang="less" scoped>
.guide-picture-wrapper {
    position: relative;
    background: #fafbfd;
    border-radius: 4px;
    font-size: 12px;
    flex-shrink: 0;
    box-sizing: border-box;
    width: 180px;
    .image-upload-strategy {
        width: 180px;
        height: 107px;
        margin-right: 4px;
        background: #fafbfd;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
    }
}
</style>
